﻿export default {
  "appName": "GinRummy",
  "version": "1.0.11",
  "fullVersion": false,
  "showErrors": false,
  "showAppLinks": false,
  "debugMode": false,
  "facebookAdId": 158327870889130,
  "showMoreGames": true,
  "showMoreGamesFB": false,
  "showIAPPage": false,
  "ShowRateGame": false,
  "TestMode": false,
  "maxPingAllowed": 500,
  "autoTestMode": false,
  "removeAds": true,
  "GAProperty":"UA-43146845-1",
  "ios": '6470861992',
  "android": 'com.jdsoftwarellc.ginrummy',
  "windows": "",
  "email": "gin@jdsoftwarellc.com",
  "emailSubject": "Feedback",
  "shareUrl": "https://cardsjd.com/ginrummy/",
  "shareTitle": "Gin Rummy",
  "shareText": "Let's play Gin Rummy",
}

         
